import React from 'react';
import styles from './Users.module.scss';
import HeaderBodyBox from '../../../../../../common/HeaderBodyBox/HeaderBodyBox';

const Users = ({ additionalDetails, additionalDocMetaData, selectedCompany }) => {
    const fieldsContent = (
        <div className={styles.Fields}>
            {Object.entries(additionalDetails || {}).map(([key, value]: any) => (
                <div key={key} className={styles.Field}>
                    <div>{value.placeholder}</div>
                    <div>{value.value || '-'}</div>
                </div>
            ))}
        </div>
    );

    return (
        <div className={styles.Container}>
            <HeaderBodyBox title="User Submitted Details" className={styles.Card}>
                {fieldsContent}
            </HeaderBodyBox>
        </div>
    );
};

export default Users;
